<template>
  <div class="profil-container" v-if="alamat && alamat.length > 0">
    <h3 class="profil-title">
      <span v-if="isEdit" class="editRow" @click="editRow(alamat[0])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ $get(alamat[0], 'text') }}
    </h3>
    <p class="profil-subtitle">
      <span v-if="isEdit" class="editRow" @click="editRow(alamat[1])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ $get(alamat[1], 'text') }}
    </p>

    <div class="vendor-form-wrapper">
      <div v-for="(item, index) in alamat.slice(2)" :key="index" class="vendor-form">
        <span v-if="isEdit" class="editRow" @click="editRow(item)"><span class="fa fa-edit pointer ml20"></span></span>
        <p class="vendor-form-label">
          {{ $get(item, 'text') }}
          <span v-if="item.is_mandatory" class="text-ast">*</span>
        </p>

        <textarea v-if="item.name === 'Alamat-3'" class="vendor-input" autocomplete="alamat" />

        <div v-if="item.name === 'Alamat-4'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Negara" label="negara" autocomplete="negara" />
        </div>

        <div v-if="item.name === 'Alamat-5'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Provinsi" label="desc" />
        </div>

        <div v-if="item.name === 'Alamat-6'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Kota" label="desc" autocomplete="kota" />
        </div>

        <div v-if="item.name === 'Alamat-7'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Kecamatan" label="desc" />
        </div>

        <div v-if="item.name === 'Alamat-8'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Kelurahan" label="desc" />
        </div>

        <the-mask v-if="item.name === 'Alamat-9'" class="vendor-input" :mask="['######']"
          placeholder="Isikan kodepos" />

        <div v-if="item.name === 'Alamat-10'" class="phone-input">
          <the-mask class="phone-input__code" :mask="['+###']" />
          <the-mask class="phone-input__phone" :mask="['####################']" />
        </div>

        <input v-if="item.name === 'Alamat-11'" type="text" class="vendor-input" autocomplete="email" />

        <input v-if="item.question_type !== 'default' && item.question_type === 'text'" type="text"
          class="vendor-input" />
        <textarea v-if="item.question_type !== 'default' && item.question_type === 'textarea'" class="vendor-input" />
        <div class="vendor-input flex-row" v-if="item.question_type !== 'default' && item.question_type === 'radio'">
          <div class="input-20">
            <input type="radio" name="ya" value="ya" v-model="item.value" />
            <label class="ml20" for="ya">Ya</label>
          </div>
          <div class="input-20">
            <input type="radio" name="tidak" value="tidak" v-model="item.value" />
            <label class="ml20" for="tidak">Tidak</label>
          </div>
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'date-picker'" type="date"
          class="vendor-input" />
        <div v-if="item.question_type !== 'default' && item.question_type === 'date-range'" class="vendor-input">
          <input type="date" class="w-50" />
          <input type="date" class="w-50" />
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'attachment'" type="file"
          class="vendor-input" />
      </div>
    </div>

    <div class="btn-landing-icons" @click="addQuestion">
      <p class="icons-btn-landing">+</p>
      <span class="text-btn-landing">Tambah</span>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goBank()" class="btn-landing">Selanjutnya</div>
    </div>
    <EditPertanyaan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
    <AddPertanyaan v-if="showModalAdd" @closeModal="closeModalAdd" class="notAll" />
  </div>

</template>

<script>
export default {
  name: 'alamat',
  props: {
    isEdit: Boolean
  },
  components: {
    EditPertanyaan: () => import('@/components/masterdata/landing-page/edit/edit-pertanyaan.vue'),
    AddPertanyaan: () => import('@/components/masterdata/landing-page/add/tambah-pertanyaan.vue'),
  },
  data() {
    return {
      showModalEdit: false,
      showModalAdd: false,
      editData: null,
    }
  },
  computed: {
    alamat() {
      const data = this.$store.state.mdLandingStore.alamat
      return data
    },
  },
  methods: {
    editRow(data) {
      this.editData = data
      this.showModalEdit = true
    },

    addQuestion() {
      this.showModalAdd = true;
    },

    closeModalAdd() {
      this.showModalAdd = false;
    },

    closeModal() {
      this.showModalEdit = false
    },

    goBack() {
      const query = this.$store.state.landingpage.query
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
    },
    goBank() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
    },
  },
}
</script>
